export class WidgetIFrameLoader {
    url: string;
    isWidgetError: boolean;
    widgetErrorModel: WidgetError;

    constructor() {
        this.url = null;
        this.isWidgetError = false;
        this.widgetErrorModel = new WidgetError;
    }
}

export class WidgetError {
    title: string;
    message: string;

    constructor() {
        this.title = null;
        this.message = null;
    }
}